import { render, staticRenderFns } from "./DefuncionesTemporalesEn.vue?vue&type=template&id=bcbfbb18&"
import script from "./DefuncionesTemporalesEn.vue?vue&type=script&lang=js&"
export * from "./DefuncionesTemporalesEn.vue?vue&type=script&lang=js&"
import style0 from "./DefuncionesTemporalesEn.vue?vue&type=style&index=0&id=bcbfbb18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports